class AdTemplateSelector {

    constructor($rootScope, CONTENT_TYPE, ApiService, SHARING_TYPES) {

    	var _self = this;

        return {
            restrict: 'E',
            templateUrl: 'builder/template-selector.html',
            scope: {
            	"template": "=",
                "campaignId": "@",
                "closeFn": "&"
            },
            link: ($scope, $el, $attr) => {

            	_self.$scope = $scope;
                _self.$el = $el;

                let typesArr = Object.keys(SHARING_TYPES).map((k) => SHARING_TYPES[k])
                $scope.nonStandardTypes = typesArr.splice(typesArr.indexOf(SHARING_TYPES.STANDARD), 1)

                $scope.filterObj = {
                    "sharing": SHARING_TYPES.STANDARD
                }
                
                $scope.switchView = (view, $el) => {
                    let allElements = Array.from(document.querySelectorAll('.template-group-select'))
                    for (let element of allElements) {
                      element.classList.remove('template-group-selected')
                    }
                    $el.classList.add('template-group-selected');
                    $scope.filterObj.sharing = view == "standard" ? SHARING_TYPES.STANDARD : $scope.nonStandardTypes;
                }

                ApiService.list(CONTENT_TYPE.TEMPLATE, "campaign=" + $scope.campaignId).then((response) => {
                    $scope.templates = response.data;
                });

                $rootScope.$on('template-selector-show', () => {
                    $el.css({top: "1vh"});
                });

                $rootScope.$on('template-selector-hide', () => {
                    $el.css({top: "101vh"});
                });

                $scope.$on("select-template", (template) => {
                    $el.css({top: "101vh"});
                });

                $scope.close = () => {
                    $scope.closeFn();
                };

            }             
        };

    }


}

angular.module('cpm')
    .directive('adTemplateSelector', ["$rootScope", "CONTENT_TYPE", "ApiService", "SHARING_TYPES", ($rootScope, CONTENT_TYPE, ApiService, SHARING_TYPES) => {
        'use strict';
        return new AdTemplateSelector($rootScope, CONTENT_TYPE, ApiService, SHARING_TYPES);
    }]);
